export default __webpack_public_path__ + "static/media/child.3542f5e8.svg";